baseApp.service('TranslationService', function() {
	var defaultDictionary = 'english';

	var dictionaries = {
		terms: {
			IP: 'IP',
			VPN: 'VPN',
			TLS: 'TLS',
			WAN: 'WAN',
			LAN: 'LAN',
			MPLS: 'MPLS',
			URL: 'URL',
			SYSTEMGROUP: 'System Group',
			SUBNET: 'Subnet',
			ACCESSLOGIN: 'VPN User',
			FLOATINGIPSUBNET: 'Floating Ranges',
			HOSTSUBNET: 'Host',
			NETWORKINTERFACE: 'Network Interface',
			Networkinterface: 'Network Interface',
			ALLOCATED_IPS: 'Allocated IP',
			DNS: 'DNS',
			IPs: 'IPs',
			GlobalSettings: 'Global Settings',
			B2B: 'B2B',
			DATACENTER: 'Data Center',
			CLOUD_DC: 'Cloud Data Center',
			HEADQUARTERS: 'Headquarters',
			BRANCH: 'Branch',
			AIRPORT: 'Airport',
			OUTBOUND_INTERNET: 'Internet',
		},
		english: {
			Accesslogin: 'User',
            INTERFACEIPRANGE: 'IP Range',
			yes: 'Yes',
			no: 'No',
		}
	};

	return {
		translate: function (key, language){
			if (dictionaries.terms[key]) {
				return dictionaries.terms[key];
			}

			return dictionaries[language || defaultDictionary][key];
		}
	}
});